import React, { useState, useEffect } from "react";
import '../../stylesheets/PreLoginPage.css';
import { selectAllStrings } from '../language/languageSlice';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Splash from '../../app/Splash';
import constants from '../../constants';
import PurchaseButton from '../../components/PurchaseButton';

const PreLoginPage = () => {
    const strings = useSelector(selectAllStrings);
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if(loading) {
            setTimeout(() => {
                setLoading(false)
            }, 1000);
        }
    }, [loading]);

    return loading ? <Splash strings={strings}/> : <div id="pre_login_page">
        <div id="intro_image">
            <img alt="pre login" src="/images/pre_login.png" />
        </div>
        <div className="box">
            <h1>{strings.passion_for_camper}</h1>
            <p>{strings.join_club}</p>
            <div className="button-list">
            <button id="login_button" onClick={() => history.push('/login')}>{strings.login}</button>
            <button id="trial" className="btn" onClick={() => history.push('/free-trial')}>{strings.hours}</button>
            
            </div>
            {constants.environment == 'iOS' ? <PurchaseButton/> : null}
        </div>
    </div>
            ;
};



export default PreLoginPage;